<!-- eslint-disable -->
<template lang="pug">
    .row.school-preview(:class="{\
            'school-preview--greenHover' : profile.account.balance >= profile.toPay,\
            'school-preview--redHover': profile.account.balance < profile.toPay,\
            'school-preview--redBorder': profile.account.balance < profile.toPay\
        }")
        .col-xs-12.school-preview__column.school-preview__column_hide-name
            .school-preview__item
                router-link(
                    :to="{name: 'school:profile', params: {id: profile.id}}"
                )
                    .school-preview__avatar
                        svg-icon.school-preview__icon(name="university", size="x-large")
                div
                    router-link.school-preview__link.school-preview__link_large(
                        :to="{name: 'school:profile', params: {id: profile.id}}"
                    )
                        .preview__text.preview__text_large
                            | {{ profile.name }}
                    .school-preview__location(v-if='profile.locations && profile.locations.length')
                        svg-icon.school-preview__icon(name="pin", size="base")
                        span.preview__text
                            | {{ profile.locations[0].fullName }}
                            | &nbsp;
                            tooltip(v-if="profile.locations.length - 1 > 0")
                                | {{ $i18n.t('billing.billing_statistics_andMore', {n: profile.locations.length - 1}) }}
                                template(slot="popup")
                                    | {{ locationsTooltip }}
        .col-xs-12.school-preview__column
            .school-preview__name.hidden-xs
                router-link(
                    :to="{name: 'school:profile', params: {id: profile.id}}"
                )
                    .school-preview__avatar
                        svg-icon.school-preview__icon(name="university", size="x-large")
                div
                    router-link.school-preview__link.school-preview__link_large(
                        :to="{name: 'school:profile', params: {id: profile.id}}"
                    )
                        .preview__text.preview__text_large
                            | {{ profile.name }}
                    .school-preview__location(v-if='profile.locations && profile.locations.length')
                        svg-icon.school-preview__icon(name="pin", size="base")
                        span.preview__text
                            | {{ profile.locations[0].fullName }}
                            | &nbsp;
                            tooltip(v-if="profile.locations.length - 1 > 0")
                                | {{ $i18n.t('billing.billing_statistics_andMore', {n: profile.locations.length - 1}) }}
                                template(slot="popup")
                                    | {{ locationsTooltip }}
            .row.school-preview__info
                .col-md-6.info__column
                    .school-preview__items.school-preview__items_columned
                        .school-preview__item
                            template(v-if="profile.account.status")
                                svg-icon.school-preview__icon(name="check")
                                .preview__text {{ $i18n.t('profiles.profiles_profile_statusActive') }}
                            template(v-else)
                                svg-icon.school-preview__icon(name="cancel")
                                .preview__text {{ $i18n.t('profiles.profiles_profile_statusBlocked') }}
                        .school-preview__item
                            svg-icon.school-preview__icon(name="calendar")
                            .preview__text
                                | {{ lastTransactionDate }}
                        .school-preview__item
                            svg-icon.school-preview__icon(name="phone")
                            .preview__text(v-if="profile.phone")
                                a.school-preview__link(:href="'tel:' + profile.phone")
                                    | {{ profile.phone }}
                            .preview__text(v-else)
                                | {{ $i18n.t('list.list_user_noPhone') }}
                        .school-preview__item
                            .preview__text
                                | {{ $i18n.t('profiles.profiles_school_primaryContact') }}:&nbsp;
                                router-link.school-preview__link(
                                    :to="{name: 'user:profile', params: {id: profile.mainContact.id, type: profile.mainContact.type}}"
                                )
                                    | {{ profile.mainContact.fullName }}
                .col-md-6.info__column
                    .school-preview__items.school-preview__items_columned
                        .school-preview__item
                            svg-icon.school-preview__icon(name="money" size="x-large")
                            div
                                .preview__text.preview__text_bold
                                    | {{ $i18n.t('billing.billing_statistics_balance') }} /
                                    | {{ $i18n.t('billing.billing_statistics_toPay') }}
                                .preview__text
                                    | {{ profile.account && balanceString(profile.account.balance) }} /
                                    | {{ balanceString(profile.toPay) }}
                    .col-md-6.info__column
                        .school-preview__items.school-preview__items_columned
                            .school-preview__item
                                .preview__text
                                    | {{ $i18n.t('profiles.profiles_course_dateCreating') + ":" }}
                                .preview__text
                                    | {{ formatDate(profile.createdAt)  }}
                .col-md-6.info__column
                    .school-preview__items.school-preview__items_columned
                        .school-preview__item
                            | {{ $i18n.t('billing.billing_statistics_allStudents') }}:
                            | {{ profile.studentsAmounts['all'] }}
                        .school-preview__item
                            | {{ $i18n.t('common.common_course_mentalArithmetic') }}:
                            | {{ profile.studentsAmounts['mentalArithmetic'] }}
                .col-md-6.info__column
                    .school-preview__items.school-preview__items_columned
                        .school-preview__item
                            | {{ $i18n.t('common.common_course_fastReading') }}:
                            | {{ profile.studentsAmounts['fastReading'] }}
                        .school-preview__item
                            | {{ $i18n.t('common.common_course_onlineSchool') }}:
                            | {{ profile.studentsAmounts['onlineSchool'] }}
                        .school-preview__item
                            | {{ $i18n.t('common.common_course_mathMagic') }}:
                            | {{ profile.studentsAmounts['mathMagic'] }}
                        .school-preview__item
                            | {{ $i18n.t('common.common_course_memoryDevelopment') }}:
                            | {{ profile.studentsAmounts['memoryDevelopment'] }}
                        .school-preview__item
                            | {{ $i18n.t('common.common_course_multiplication') }}:
                            | {{ profile.studentsAmounts['multiplication'] }}
                        .school-preview__item
                            | {{ $i18n.t('common.common_course_russianLanguage') }}:
                            | {{ profile.studentsAmounts['russianLanguage'] }}
</template>

<script>
    /*eslint-disable*/
    import Dropdown from '../../../../elements/Dropdown.vue';
    import { mapState } from 'vuex';
    import moment from "moment";

    export default {
        props: {
            profile: {
                type: Object,
                default: null,
            },
            isLast: Boolean,
        },
        methods: {
            balanceString (amount) {
                const formatter = new Intl.NumberFormat('ru-RU', {
                    style: 'currency',
                    currency: 'RUB',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                });
                return formatter.format(amount);
            },
            formatDate (date) {
               return moment(date).format('YYYY-MM-DD');
            },
        },
        computed: {
            ...mapState({
               user: state => state.auth.user,
            }),
            lastTransactionDate () {
                if (this.profile.transactions && this.profile.transactions.length) {
                    return this.$i18n.t('billing.billing_lastOperationDate') + ':' + this.$moment(this.profile.transactions[0].createdAt).format('YYYY-MM-DD')
                }
                return this.$i18n.t('list.list_billing_noBalanceChanges');
            },
            selectorSize () {
                const windowWidth = window.innerWidth;
                return windowWidth >= 1200 ? 'xx-large' : 'x-large';
            },
            locationsTooltip () {
                return this.profile.locations.slice(1).map(element => element.fullName).join('\n');
            }
        },
        components: {
            Dropdown,
        }
    }
</script>

<style lang="scss" scoped>
    .school-preview {
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        padding: 16px;
    }

    .school-preview--redBorder {
        border-color: $hsl-color-red-62;
    }

    .school-preview--redHover {
        &:hover {
            background: rgba($hsl-color-red-62, 0.05);
        }
    }
    .school-preview--greenHover {
        &:hover {
            background: rgba($hsl-color-green-58, 0.05);
        }
    }

    .school-preview__column {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0;
        margin-bottom: 8px;
        @include media($xlg) {
            margin-bottom: 0;
        }
    }

    .school-preview__column:last-child {
        margin-bottom: 0;
    }

    .school-preview__column:first-child {
        margin-bottom: 16px;
    }

    .school-preview__column_hide-name {
        @include media($sm) {
            display: none;
        }
    }

    .school-preview__name {
        margin-bottom: 16px;
        display: flex;
        align-items: center;
    }

    .school-preview__location {
        display: flex;
        margin-top: 8px;
        margin-left: 16px;
    }

    .school-preview__avatar {
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: $border-radius-circle;
        background-color: #F3F8EF;
    }

    .school-preview__icon {
        color: $hsl-color-green-58;
    }

    .school-preview__icon_blue {
        color: $hsl-color-blue-56;
    }

    .school-preview__items {
        display: flex;
        margin: -4px 0;
    }

    .school-preview__items_columned {
        flex-direction: column;
    }

    .school-preview__item {
        display: flex;
        align-items: center;

        font-size: 13px;
        line-height: 16px;

        padding: 4px;
    }

    .preview__text {
        margin-left: 8px;
    }

    .preview__text_large {
        margin-left: 16px;
    }

    .preview__text_bold {
        font-weight: 500;
    }

    .school-preview__item:not(:last-child) {
        margin-bottom: 4px;
    }

    .school-preview__info {
        margin: -8px 0;
    }

    .info__column {
        padding: 8px 0;
    }

    .school-preview__link {
        color: $hsl-color-blue-56;
        text-decoration: none;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .school-preview__link_large {
        font-size: 16px;
        line-height: 20px;
        @include media($lg) {
            font-size: 18px;
        }
    }

    .custom-dropdown {
        top: 0;
        left: 0;
    }

    .dropdown__links {
        padding: 7px 14px;
        text-align: left;
        font-size: 16px;
        line-height: 26px;
    }

    .dropdown__link {
        padding-bottom: 7px;
        a {
            color: $hsl-color-blue-56;
            text-decoration: underline;
            &:hover {
                color: $hsl-color-blue-56;
                text-decoration: none;
            }
        }
    }

    .school-preview__money {
        margin-left: 8px;
    }
</style>
